module.exports = __webpack_public_path__ + "static/img/5.d2997d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/sp/5.png
// module id = mnYU
// module chunks = 0